"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContainerProvider = exports.usePageContainerProvider = exports.PageContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
function PageContainer({ children, }) {
    const [containerProps] = usePageContainerProvider();
    return (0, jsx_runtime_1.jsx)(react_1.Container, Object.assign({}, containerProps, { children: children }));
}
exports.PageContainer = PageContainer;
const PageContainerContext = react_2.default.createContext([{}, s => (Object.assign({}, s))]);
function usePageContainerProvider() {
    return react_2.default.useContext(PageContainerContext);
}
exports.usePageContainerProvider = usePageContainerProvider;
function PageContainerProvider({ children, }) {
    const ctx = react_2.default.useReducer((state, payload) => {
        return Object.assign(Object.assign({}, state), payload);
    }, {});
    return ((0, jsx_runtime_1.jsx)(PageContainerContext.Provider, Object.assign({ value: ctx }, { children: children })));
}
exports.PageContainerProvider = PageContainerProvider;
